// extracted by mini-css-extract-plugin
module.exports = {"input_box":"QueryInput_input_box__5RXL7","form":"QueryInput_form__3R3-I","input":"QueryInput_input__31_CE","submit_btn":"QueryInput_submit_btn__Wzgqm"};